import { FC, useState } from "react";
import { Autocomplete, Button, TextField } from "@mui/material";
import { colors } from "app/providers/theme/colors-type";

export interface IObjects {
    uid: string;
    name: string;
}

interface BasicAutocompleteProps {
    value: string;
    onChange: (field: string, value: string) => void;
    onInputChange: (field: string, value: string) => void;
    options: IObjects[];
    error?: string;
    label?: string;
    noOptionsText?: string;
    name: string;
    disabled?: boolean;
}


export const BasicAutocomplete: FC<BasicAutocompleteProps> = ({
    value,
    onChange,
    onInputChange,
    options,
    error,
    label,
    noOptionsText = "Ничего не найдено",
    name,
    disabled
}) => {
    const selectedValue = options.find((item) => item.uid === value) || null;

    const handleChange = (_event: any, newValue: IObjects | null) => {
        onChange(name, newValue ? newValue.uid : '');
    };

    const handleInputChange = (_event: any, newValue: string) => {
        onInputChange(name, newValue);
    };

    return (
        <Autocomplete
            fullWidth
            options={options}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option.uid === value.uid}
            value={selectedValue}
            onChange={handleChange}
            onInputChange={handleInputChange}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    error={!!error}
                    helperText={error}
                />
            )}
            noOptionsText={noOptionsText}
            disabled={disabled}
        />
    );
};
